import { camelToSnakeDeep } from "@/utils/utilsGrcpRest";

const WEBMAIL_KEYS = {
  address1: "address_1",
  address2: "address_2",
  address3: "address_3",
};

export default class ExternalSociety {
  constructor(society) {
    this.setData(society);
  }

  setData(society) {
    const defaultValue = {
      uuid: null,
      title: null,
      address1: null,
      address2: null,
      address3: null,
      postalCode: null,
      cedex: null,
      tel: null,
      fax: null,
      email: null,
      national: null,
      siren: null,
      city: null,
      nic: null,
      fromOldRapso: null,
    };

    const well_formated_data = { ...defaultValue, ...society };

    for (let [key, value] of Object.entries(well_formated_data)) {
      this[key] = value;
    }
  }

  toWebmailPayload() {
    return Object.fromEntries(
      Object.entries(camelToSnakeDeep({ ...this })).map(([key, value]) => [
        WEBMAIL_KEYS[key] ?? key,
        value,
      ]),
    );
  }
}
